/**
 * Garante 1 brinde por pedido (linha real no carrinho / checkout / admin).
 * Não interfere no simulador de CEP (que não dispara cart:update).
 */
(function () {
  'use strict';

  var node = document.getElementById('AndradeGiftConfig');
  if (!node) return;

  var config;
  try {
    config = JSON.parse(node.textContent || '{}');
  } catch (e) {
    return;
  }

  var variantId = Number(config.variantId);
  if (!config.enabled || !variantId) return;

  var hiddenKey = config.hiddenKey || '_andrade_gift';
  var hiddenValue = config.hiddenValue || '1';
  var labelKey = config.labelKey || 'Brinde';
  var labelValue = config.labelValue || 'Incluso no pedido';
  var SOURCE = 'andrade-gift';
  var lock = Promise.resolve();

  function jsonFetch(url, options) {
    return fetch(
      url,
      Object.assign({ credentials: 'same-origin', headers: { Accept: 'application/json' } }, options || {})
    ).then(function (res) {
      return res.json().then(
        function (body) {
          return { ok: res.ok, status: res.status, body: body };
        },
        function () {
          return { ok: res.ok, status: res.status, body: null };
        }
      );
    });
  }

  function isAutoGift(item) {
    if (!item) return false;
    var props = item.properties || {};
    if (String(props[hiddenKey] || '') === hiddenValue) return true;
    if (labelKey && String(props[labelKey] || '') !== '') return true;
    if (Number(item.variant_id) === variantId) return true;
    var handle = String(item.handle || (item.product && item.product.handle) || '');
    var type = String(item.product_type || (item.product && item.product.type) || '');
    if (handle === 'brinde-surpresa-andrade-joias') return true;
    if (type === 'Brinde') return true;
    return false;
  }

  function isPaidLine(item) {
    if (!item) return false;
    if (isAutoGift(item)) return false;
    return Number(item.variant_id) !== variantId;
  }

  function giftProperties() {
    var props = {};
    props[hiddenKey] = hiddenValue;
    props[labelKey] = labelValue;
    return props;
  }

  function notifyCart(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: SOURCE,
          data: {
            source: SOURCE,
            itemCount: cart && cart.item_count,
          },
        },
      })
    );
  }

  function ensureGift() {
    lock = lock.catch(function () {}).then(function () {
      return jsonFetch('/cart.js').then(function (res) {
        var cart = res.body;
        if (!cart || !Array.isArray(cart.items)) return null;

        var paid = [];
        var gifts = [];
        cart.items.forEach(function (item) {
          if (isAutoGift(item)) gifts.push(item);
          else if (isPaidLine(item)) paid.push(item);
        });

        if (!paid.length) {
          if (!gifts.length) return cart;
          var updates = {};
          gifts.forEach(function (item) {
            updates[item.key] = 0;
          });
          return jsonFetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates }),
          }).then(function (updated) {
            var next = updated.body || cart;
            notifyCart(next);
            return next;
          });
        }

        if (gifts.length === 1 && Number(gifts[0].quantity) === 1) return cart;

        var ops = Promise.resolve();
        if (gifts.length > 1 || (gifts.length === 1 && Number(gifts[0].quantity) !== 1)) {
          var qtyUpdates = {};
          gifts.forEach(function (item, index) {
            qtyUpdates[item.key] = index === 0 ? 1 : 0;
          });
          ops = jsonFetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: qtyUpdates }),
          });
        }

        return ops.then(function () {
          if (gifts.length) {
            return jsonFetch('/cart.js').then(function (latest) {
              notifyCart(latest.body);
              return latest.body;
            });
          }
          return jsonFetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [
                {
                  id: variantId,
                  quantity: 1,
                  properties: giftProperties(),
                },
              ],
            }),
          }).then(function (added) {
            if (!added.ok) {
              return jsonFetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({
                  id: variantId,
                  quantity: 1,
                  properties: giftProperties(),
                }),
              }).then(function (retry) {
                if (!retry.ok) return cart;
                return jsonFetch('/cart.js').then(function (latest) {
                  notifyCart(latest.body);
                  return latest.body;
                });
              });
            }
            return jsonFetch('/cart.js').then(function (latest) {
              notifyCart(latest.body);
              return latest.body;
            });
          });
        });
      });
    });
    return lock;
  }

  document.addEventListener(
    'cart:update',
    function (event) {
      var source = event && event.detail && event.detail.data && event.detail.data.source;
      if (source === SOURCE) return;
      ensureGift();
    },
    false
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      ensureGift();
    });
  } else {
    ensureGift();
  }

  function wrapCheckout() {
    if (!window.AndradeCheckout || typeof window.AndradeCheckout.go !== 'function') return;
    if (window.AndradeCheckout.__giftWrapped) return;
    window.AndradeCheckout.__giftWrapped = true;
    var prev = window.AndradeCheckout.go;
    window.AndradeCheckout.go = function () {
      return ensureGift().then(function () {
        return prev();
      });
    };
  }

  wrapCheckout();
  document.addEventListener('DOMContentLoaded', wrapCheckout);
  window.setTimeout(wrapCheckout, 0);
  window.setTimeout(wrapCheckout, 400);
  window.AndradeGift = {
    variantId: variantId,
    lineItem: function () {
      return { id: variantId, quantity: 1, properties: giftProperties() };
    },
    ensure: ensureGift,
  };
})();
